import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";

export default function AdminCoupons() {
  const [items, setItems] = useState([]);
  const [code, setCode] = useState("");
  const [pct, setPct] = useState(10);

  const load = useCallback(async () => {
    try { setItems((await api.get("/admin/coupons")).data); }
    catch { toast.error("Failed to load coupons"); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    try {
      await api.post("/admin/coupons", { code: code.trim(), percent_off: parseFloat(pct), active: true });
      toast.success("Coupon saved");
      setCode(""); setPct(10); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
  };

  const toggle = async (c) => {
    await api.post("/admin/coupons", { ...c, active: !c.active });
    load();
  };

  const del = async (c) => {
    if (!window.confirm(`Delete coupon ${c.code}?`)) return;
    await api.delete(`/admin/coupons/${c.code}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div>
      <h1 className="font-display text-4xl mb-6">Coupons</h1>

      <form onSubmit={add} className="border border-white/10 rounded p-5 bg-[var(--cl-surface)] flex flex-wrap gap-3 items-end mb-8">
        <div className="flex-1 min-w-[160px]">
          <label className="text-label text-zinc-500">Code</label>
          <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="SUMMER25"
                 data-testid="coupon-code" className="mt-1 w-full bg-black border border-white/10 rounded px-3 py-2 text-sm" />
        </div>
        <div className="w-32">
          <label className="text-label text-zinc-500">% Off</label>
          <input type="number" min="1" max="100" value={pct} onChange={(e) => setPct(e.target.value)}
                 data-testid="coupon-pct" className="mt-1 w-full bg-black border border-white/10 rounded px-3 py-2 text-sm" />
        </div>
        <button className="btn-primary" data-testid="coupon-add"><Plus size={16} className="inline mr-1 -mt-0.5" /> Add</button>
      </form>

      <div className="space-y-2" data-testid="coupons-list">
        {items.length === 0 && <div className="text-zinc-500">No coupons yet.</div>}
        {items.map((c) => (
          <div key={c.code} className="flex items-center gap-4 border border-white/10 rounded p-3 bg-[var(--cl-surface)]">
            <div className="font-display text-2xl w-40">{c.code}</div>
            <div className="text-[var(--cl-orange)] font-bold">{c.percent_off}%</div>
            <button onClick={() => toggle(c)}
                    className={`text-xs px-3 py-1 rounded border ${c.active ? "border-green-500/50 text-green-400" : "border-white/15 text-zinc-500"}`}>
              {c.active ? "Active" : "Disabled"}
            </button>
            <button onClick={() => del(c)} className="ml-auto p-2 hover:text-[var(--cl-primary)]" data-testid={`del-coupon-${c.code}`}>
              <Trash2 size={16} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
